import React, { useContext } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import CanvasRotateButton from 'components/buttons/CanvasRotateButton';

export default function CanvasRotateTool({ isActive }) {
  const {
    rotateCanvasCW,
    rotateCanvasCCW,
    flipCanvasHorizontal,
    flipCanvasVertical,
  } = useContext(CanvasContext);

  if (!isActive) return null;

  return (
    <>
      <div className="mx-auto flex flex-wrap items-center gap-3">
        <CanvasRotateButton
          onClick={rotateCanvasCCW}
          title="Rotate the entire canvas 90° left"
          image="rotate90"
          rotateClass="-rotate-180"
          caption="-90 &deg;"
        />

        <CanvasRotateButton
          onClick={rotateCanvasCW}
          title="Rotate the entire canvas 90° right"
          image="rotate90"
          rotateClass="transform -scale-x-100"
          caption="90 &deg;"
        />

        <CanvasRotateButton
          onClick={flipCanvasHorizontal}
          title="Flip the entire canvas horizontally"
          image="flip-white"
          caption="horizontal"
        />

        <CanvasRotateButton
          onClick={flipCanvasVertical}
          title="Flip the entire canvas vertically"
          image="flip-white"
          rotateClass="-rotate-90"
          caption="vertical"
        />
      </div>
    </>
  );
}
